export const patterns = {
  email:
    /^([a-zA-Z0-9!#$%&'*+/=?^_‘{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_‘{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9]))$/,
  password: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
  phone: /^\+(?:[0-9] ?){10,13}[0-9]$/,
  name: /^[A-ZА-ЯЁ]/,
  time: /^([0-1][0-9]|[2][0-3]):([0-5][0-9])$/,
};
